$(function () {
    var supportsIntersectionObserver = ('IntersectionObserver' in window);

    visaNyckeltalVidScroll();

    function visaNyckeltalVidScroll() {
        var nyckeltal = document.getElementById('nyckeltal');

        var options = {
            rootMargin: '-20% 0% -20% 0%'
        };

        if (!supportsIntersectionObserver || (typeof (nyckeltal) === 'undefined' || nyckeltal === null)) {
            return;
        }

        initBelopp($('#nyckeltal'));

        /* eslint-disable */
        var observer = new IntersectionObserver(function (entries, observer) {
            for (var i = 0; i < entries.length; i++) {
                if (entries[i].isIntersecting) {
                    intersectionHandler(entries[i]);
                }
            }
        }, options);
        /* eslint-enable */

        observer.observe(nyckeltal);

        function intersectionHandler(entry) {
            var section = $('#' + entry.target.id);
            if (section.length && !section.hasClass('active')) {
                animateBelopp(section);
            }
        }
    }

    function initBelopp(section) {
        var numbers = section.find('.belopp');
        if (numbers.length) {
            numbers.each(function () {
                var belopp = $(this);
                var start = belopp.data('startbelopp');
                if (start) {
                    belopp.text(start.toLocaleString());
                }
            });
        }
    }

    function animateBelopp(section) {
        var numbers = section.find('.belopp');
        if (numbers.length && !numbers.hasClass('animate')) {
            numbers.each(function () {
                var belopp = $(this);
                var start = belopp.data('startbelopp');
                var end = belopp.data('slutbelopp');
                if (start && end && !belopp.hasClass('animate')) {
                    belopp.addClass('animate');
                    animateValue(belopp, start, end, 1200);
                }
            });
        }
    }

    function animateValue(obj, start, end, duration) {
        if (isFloat(end)) {
            obj.prop('Counter', start).animate({
                Counter: end
            }, {
                duration: duration,
                step: function (n) {
                    obj.text(((Math.round(n * 10) / 10).toLocaleString(undefined, {
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1
                    })));
                },
                complete: function () {
                    obj.text(hanteraTusental(obj.text()));
                }
            });
        } else if (isInt(end)) {
            obj.prop('Counter', start).animate({
                Counter: end
            }, {
                duration: duration,
                step: function (n) {
                    obj.text(Math.ceil(n)).toLocaleString();
                },
                complete: function () {
                    obj.text(hanteraTusental(obj.text()));
                }
            });
        }
    }

    function isInt(n) {
        return String(n).indexOf('.') < 0;
    }

    function isFloat(n) {
        return String(n).indexOf('.') > -1;
    }

    function hanteraTusental(nr) {
        var str = nr.toString().replace(/\s+/g, '');
        var komma = str.indexOf(',');
        var result = komma < 0 ? str : str.slice(0, komma);

        for (var i = result.length - 3; i > 0; i -= 3) {
            result = result.slice(0, i) + ' ' + result.slice(i);
        }

        if (komma > -1) {
            result += str.slice(komma);
        }
        return result;
    }
});
